import React, { Fragment, useContext, useEffect, memo } from "react";
import { FormattedMessage } from "react-intl";
import build from "redux-object";
import { Text, Box, Spinner } from "@cyberalarm/ui";

import { notFound, loading } from "./schema";
import { ListItem } from "./list-item";

import { domainSelectors, DomainStateContext, StoreContext } from "store";
import { useDomainsList } from "hooks";

interface ListProps {
  setID: (id: string) => void;
  sortOption: string;
  sortOrder: string;
}

export const List = memo(({ setID, sortOption, sortOrder }: ListProps) => {
  const state = useContext(DomainStateContext);
  const { sortPreferences, domainList } = useContext(StoreContext);
  const domainListSort = `${sortOption}_${sortOrder}`;
  const domains = domainSelectors.getDomainList(state);
  useDomainsList(`domains?sort=${domainListSort}`);

  useEffect(() => {
    const id = sortPreferences.currentDomainId ?? domains.result[0];
    setID(id);
  }, [setID, domains.result, sortPreferences.currentDomainId]);

  return (
    <Fragment>
      <Box
        marginBottom="32px"
        height="calc(90vh - 48px)"
        overflowX="hidden"
        overflowY="auto"
      >
        {domainList.loading && (
          <Box alignItems="center" justifyContent="center" padding="2rem">
            <Text color="logo" textAlign="center">
              <FormattedMessage {...loading} />
            </Text>
            <Spinner width="4rem" height="4rem" margin="2rem auto" />
          </Box>
        )}

        {!domainList.loading &&
          Boolean(domains.result.length) &&
          domains.result.map((id: string) => {
            const domain: BuiltDomain = build(domains.entities, "domain", id);
            return <ListItem key={id} setID={setID} {...domain} />;
          })}
        {!domainList.loading && !Boolean(domains.result.length) && (
          <Box marginY="50px" alignItems="center">
            <Text fontSize={1} color="grays.2">
              <FormattedMessage {...notFound} />
            </Text>
          </Box>
        )}
      </Box>
    </Fragment>
  );
});
